import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSpinner} from '@fortawesome/free-solid-svg-icons'

interface LoaderInlineProps {
  text?: string
}

const LoaderInline = ({text = 'Loading...'}) => {
  return (
    <div className="flex gap-1 items-center">
      <FontAwesomeIcon icon={faSpinner} className="text-lg loader-spinner" />
      <span className="text-sm">{text}</span>
    </div>
  )
}

export default LoaderInline
